import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layouts/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/layouts/layout/layout.component').then(
        (m) => m.LayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/index/index.component').then((m) => m.IndexComponent),
      },
      {
        path: 'clubs',
        loadComponent: () =>
          import('./pages/clubs/clubs.component').then((m) => m.ClubsComponent),
      },
      {
        path: 'clubs/:id',
        loadComponent: () =>
          import('./pages/club/club.component').then((m) => m.ClubComponent),
      },
      {
        path: 'coaches',
        loadComponent: () =>
          import('./pages/coaches/coaches.component').then(
            (m) => m.CoachesComponent
          ),
      },
      {
        path: 'coaches/:id',
        loadComponent: () =>
          import('./pages/coach/coach.component').then((m) => m.CoachComponent),
      },
      {
        path: 'sponsors',
        loadComponent: () =>
          import('./pages/sponsors/sponsors.component').then(
            (m) => m.SponsorsComponent
          ),
      },
      {
        path: 'sponsors/:id',
        loadComponent: () =>
          import('./pages/sponsor/sponsor.component').then(
            (m) => m.SponsorComponent
          ),
      },
      {
        path: 'match-sessions',
        loadComponent: () =>
          import('./pages/match-sessions/match-sessions.component').then(
            (m) => m.MatchSessionsComponent
          ),
      },
      {
        path: 'match-sessions/:id',
        loadComponent: () =>
          import('./pages/match-session/match-session.component').then(
            (m) => m.MatchSessionComponent
          ),
      },
      {
        path: 'matches/:id',
        loadComponent: () =>
          import('./pages/match/match.component').then(
            (m) => m.MatchComponent
          ),
      },
      {
        path: 'tournaments',
        loadComponent: () =>
          import('./pages/tournaments/tournaments.component').then(
            (m) => m.TournamentsComponent
          ),
      },
      {
        path: 'tournaments/:id',
        loadComponent: () =>
          import('./pages/tournament/tournament.component').then(
            (m) => m.TournamentComponent
          ),
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./pages/events/events.component').then(
            (m) => m.EventsComponent
          ),
      },
      {
        path: 'events/:id',
        loadComponent: () =>
          import('./pages/event/event.component').then((m) => m.EventComponent),
      },
      {
        path: 'marketplace',
        loadComponent: () =>
          import('./pages/marketplace/marketplace.component').then(
            (m) => m.MarketplaceComponent
          ),
      },
      {
        path: 'marketplace/:id',
        loadComponent: () =>
          import(
            './pages/marketplace-listing/marketplace-listing.component'
          ).then((m) => m.MarketplaceListingComponent),
      },
      {
        path: 'venues',
        loadComponent: () =>
          import('./pages/venues/venues.component').then(
            (m) => m.VenuesComponent
          ),
      },
      {
        path: 'venues/:id',
        loadComponent: () =>
          import('./pages/venue/venue.component').then((m) => m.VenueComponent),
      },
      {
        path: 'courts/:id',
        loadComponent: () =>
          import('./pages/court/court.component').then((m) => m.CourtComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policy.component').then(
            (m) => m.PrivacyPolicyComponent
          ),
      },
      {
        path: 'terms-of-use',
        loadComponent: () =>
          import('./pages/terms-of-use/terms-of-use.component').then(
            (m) => m.TermsOfUseComponent
          ),
      },
    ],
  },
];
